import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BookIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Book",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9 2h17.5c.97 0 1.75.78 1.75 1.75v17.5c0 .97-.78 1.75-1.75 1.75H9.04c-.85 0-1.57.59-1.75 1.39q-.03.18-.03.36c0 .97.78 1.75 1.75 1.75h17.46c.85 0 1.56.59 1.75 1.39.02.12.04.24.04.36 0 .97-.78 1.75-1.75 1.75H9a5.25 5.25 0 0 1-5.25-5.25V7.25C3.75 4.35 6.1 2 9 2"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27 13H7c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h20c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h20c.55 0 1 .45 1 1s-.45 1-1 1M27 29H7c-1.65 0-3-1.35-3-3v-4c0-1.65 1.35-3 3-3h20c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h20c.55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27 21H7c-1.65 0-3-1.35-3-3v-4c0-1.65 1.35-3 3-3h20c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h20c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};